import { render, staticRenderFns } from "./SocialProof.vue?vue&type=template&id=3c05ca80&scoped=true&"
import script from "./SocialProof.vue?vue&type=script&lang=js&"
export * from "./SocialProof.vue?vue&type=script&lang=js&"
import style0 from "./SocialProof.vue?vue&type=style&index=0&id=3c05ca80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c05ca80",
  null
  
)

export default component.exports